module.exports = __webpack_public_path__ + "img/58.7a604de1.jpg";